import { Mention } from '@syncfusion/ej2-dropdowns';
/**
 * `Mention renderer` module is used to render Mention control in BlockEditor.
 *
 * @hidden
 */
export class MentionRenderer {
    constructor(editor) {
        this.editor = editor;
    }
    /**
     * Renders the mention control in BlockEditor.
     *
     * @param {IMentionRenderOptions} args - specifies  the arguments.
     * @returns {Mention} - returns the mention object.
     * @hidden
     */
    renderMention(args) {
        return new Mention({
            mentionChar: args.mentionChar,
            dataSource: args.dataSource,
            highlight: args.highlight,
            allowSpaces: true,
            suffixText: '',
            fields: args.fields,
            itemTemplate: args.itemTemplate,
            displayTemplate: args.displayTemplate,
            popupWidth: args.popupWidth,
            popupHeight: args.popupHeight,
            change: args.change,
            filtering: args.filtering,
            beforeOpen: args.beforeOpen,
            select: args.select,
            locale: this.editor.locale,
            cssClass: (args.cssClass + (this.editor.cssClass ? (' ' + this.editor.cssClass) : '')),
            opened: (e) => {
                this.editor.blockManager.observer.notify('mentionOpened');
                if (args.opened) {
                    args.opened.call(this, e);
                }
            },
            closed: (e) => {
                if (args.beforeClose) {
                    args.beforeClose.call(this, e);
                }
            }
        }, args.element);
    }
}
